<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <!--for overlay :loading="get_ay_std_ft_loader" -->
        <v-card v-if="fees_structure_data!=null" class="box">
            <v-card-text>
               <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Fees Payment Schedule</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <!-- <v-row justify="center">
                    <v-col sm="3">
                        <h3>Fees Payment Schedule</h3>
                    </v-col>
                </v-row> -->
                <v-row justify="center" dense>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-combobox rounded dense required v-model="current_academic_year" :items="fees_structure_data.academic_year_list" item-text="Application Status Data" label="Academic Year" outlined />
                    </v-col>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-combobox rounded dense required v-model="std" :items="fees_structure_data.standard_list" item-text="Standard" label="Standard" outlined />
                    </v-col>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-combobox rounded dense required v-model="fees_type" :items="fees_structure_data.fees_deposite_type" item-text="Fees Type" label="Fees Type" outlined />
                    </v-col>
                    <v-col sm="2">
                        <v-btn class="mt-6 button " @click="getTotalFees()" :loading="fetch_btn_load">Fetch</v-btn>
                    </v-col>
                </v-row>

                <v-row justify="center" dense>
                    <v-col sm="2">
                        <v-text-field rounded dense label="Total Fees" placeholder="Total Fees" outlined :value="total_fees_amount" :disabled="total_fee" filled></v-text-field>
                    </v-col>
                </v-row>

                <v-form v-model="isValidForm1">
                    <v-row justify="center" dense v-if="showform">
                        <v-col sm="2">
                            <v-combobox
                                dense
                                rounded
                                required
                                v-model="selected_installment"
                                :items="installment"
                                :rules="installment < 0 || installment==null || installment==''
                                    ? [' Installment is required']
                                    : []
                                "
                                item-text="Installment"
                                label="Installment"
                                outlined
                            />
                        </v-col>
                        <v-col sm="2">
                            <v-text-field
                                dense
                                rounded
                                label="Installment Amount"
                                placeholder="Installment Amount"
                                outlined
                                v-model="install_amount"
                                :rules="install_amount < 0 || install_amount==null || install_amount==''
                                ? [' Amount is required']
                                : []
                            "
                            ></v-text-field>
                        </v-col>
                        <v-col sm="2">
                            <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        dense
                                        rounded
                                        v-model="dateFormatted"
                                        :rules="dateFormatted==null || dateFormatted==''? [' Date is required']
                                            : []
                                        "
                                        label="Last Date"
                                        hint="MM/DD/YYYY format"
                                        persistent-hint
                                        outlined
                                        @blur="date2 = parseDate(dateFormatted)"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="date2" no-title @input="menu2 = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col sm="2">
                            <v-btn class="button" :disabled="!isValidForm1" @click="saveInstallment()" :loading="addinst">Save</v-btn>
                        </v-col>
                    </v-row>
                </v-form>
                <v-row v-if="showform" justify="center">
                    <v-col sm="12">
                        <template>
                            <v-card class="box">
                               <v-toolbar flat dense class="toolbar">
                                <v-toolbar-title>Payment Schedule</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                                <v-card-title>
                                    <!-- Payment Schedule -->
                                    <v-spacer></v-spacer>
                                    <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                                </v-card-title>

                                <v-data-table :headers="headers" :items="installmentschedule" dense class="mytable elevation-1" :search="search">
                                    <template v-slot:item.action="{ item }">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-avatar style size="25" class="edit-avatar">
                                                    <v-icon class="edit-v-icon mr-2" @click="editPaymentSchedule(item)" title="edit" style>edit</v-icon>
                                                </v-avatar>
                                            </template>
                                            <span>Edit</span>
                                        </v-tooltip>
                                        <v-btn text> <v-icon color="grey" @click="deleteSchedule(item.fps)"> mdi-delete</v-icon></v-btn>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </template>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <div>
            <v-dialog v-model="dialog" max-width="500px">
                <v-card class="mx-auto">
                    <v-card-title class="toolbar">
                        Edit Payment Schedule
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field outlined rounded dense v-model="editedItem.amount" label="Amount" type="number"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <v-text-field outlined rounded dense v-model="editedItem.install" label="Installment" :readonly="true" :filled="true" hint="noneditable" persistent-hint></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field rounded dense v-model="editedItem.deadline" name="deadline" hint="DD/MM/YYYY" persistent-hint @blur="date1 = parseDate(editedItem.deadline)" v-on="on" outlined></v-text-field>
                                    </template>
                                    <v-date-picker v-model="date1" no-title @input="menu1 = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="button" @click="dialog = false">Close</v-btn>
                        <v-btn class="button" @click="saveEditedPaymentSchedule()">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
        {{status}}
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            isValidForm1: true,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            dialog: false,
            installmentschedule: "",
            search: "",
            msg: "",
            fsm: "",
            showform: false,
            addinst: false,
            fees_structure_data: null,
            current_academic_year: null,
            fees_type: null,
            std: null,
            get_ay_std_ft_loader: true,
            total_fee: true,
            total_fees_amount: "",
            fetch_btn_load: false,
            selected_installment: "",
            installment: "",
            install_amount: "",
            date2: new Date().toISOString().substr(0, 10),
            date1: new Date().toISOString().substr(0, 10),
            dateFormatted: "",
            menu1: false,
            menu2: false,
            fps_id: "",
            status: "",
            headers: [
                { text: "Installment", value: "install", sortable: true },
                { text: "Amount", value: "amount", sortable: true },
                { text: "Last Date", value: "deadline", sortable: true },
                { text: "Action", value: "action", sortable: false },
            ],
            editedIndex: -1,
            editedItem: {
                install: "",
                amount: "",
                deadline: "",
                fps: "",
            },
        }),
        watch: {
            date2(val) {
                this.dateFormatted = this.formatDate(this.date2);
            },
            date1(val) {
                this.editedItem.deadline = this.formatDate(this.date1);
            },
        },
        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            editPaymentSchedule(item) {
                this.editedIndex = this.installmentschedule.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },
            get_ay_std_ft() {
                this.get_ay_std_ft_loader = true;

                axios
                    .post("/feesMaster/get_ay_std_ft")
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.fees_structure_data = res.data.fees_structure_data;
                            this.current_academic_year = res.data.fees_structure_data.current_academic_year;
                            this.std = this.fees_structure_data.standard_list[0];
                            this.fees_type = this.fees_structure_data.fees_deposite_type[0];
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.get_ay_std_ft_loader = false;
                    });
            },
            getTotalFees() {
                this.fetch_btn_load = true;
                const data = {
                    ay: this.current_academic_year,
                    feetype: this.fees_type,
                    standard: this.std,
                };
                axios
                    .post("/feesMaster/getTotalFees", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.total_fees_amount = res.data.total_fee;
                            this.installment = res.data.installment;
                            this.selected_installment = res.data.installment[0];
                            this.fsm = res.data.fsm;
                            this.installmentschedule = res.data.installmentschedule;
                            this.showform = true;
                            this.fetch_btn_load = false;
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.get_ay_std_ft_loader = false;
                    });
            },
            formatDate(date) {
                if (!date) return null;
                const [year, month, day] = date.split("-");
                return `${day}/${month}/${year}`;
            },
            parseDate(date) {
                if (!date) return null;
                const [month, day, year] = date.split("/");
                return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            },
            saveInstallment() {
                const data = {
                    lastdate: this.dateFormatted,
                    install_amount: this.install_amount,
                    installment: this.selected_installment,
                    fsm_id: this.fsm,
                };
                if (this.total_fees_amount > this.install_amount) {
                    axios
                        .post("/feesMaster/saveInstallment", data)
                        .then((res) => {
                            if (res.data.msg == "200") {
                                if (res.data.status == "errmsg") {
                                    this.showSnackbar("#b71c1c", "Already present/Installment total exceeds total fees...!"); // show snackbar on success
                                } else {
                                    this.showSnackbar("#4caf50", "Saved Successfully..."); // show snackbar on success
                                    // this.installment=res.data.installment
                                }

                                this.getTotalFees();
                            } else {
                                //error
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        })
                        .finally(() => {
                            //close loader
                        });
                } else {
                    //alert("");
                    this.showSnackbar("#b71c1c", "Installment amount exceeds Total amount...!"); // show snackbar on success
                }
            },
            saveEditedPaymentSchedule() {
                const data = {
                    lastdate: this.editedItem.deadline,
                    install: this.editedItem.install,
                    amount: this.editedItem.amount,
                    fps: this.editedItem.fps,
                };
                axios
                    .post("/feesMaster/saveEditedInstallment", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.installmentschedule = res.data.installmentschedule;
                            this.dialog = false;
                            if (res.data.status) {
                                this.showSnackbar("#b71c1c", res.data.status); // show snackbar on success
                            } else {
                                this.showSnackbar("#4caf50", "Saved Successfully..."); // show snackbar on success
                            }
                        } else {
                            this.showSnackbar("#b71c1c", "Error..."); // show snackbar on success
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            deleteSchedule(fps) {
                const data = {
                    fps: fps,
                };
                if (!confirm("are you sure to delete the item!")) return;
                axios
                    .post("/feesMaster/deleteInstallment", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            //this.installmentschedule=res.data.installmentschedule
                            this.getTotalFees();
                            this.showSnackbar("#4caf50", "Successfully Deleted..."); // show snackbar on success
                            //this.dialog = false
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                    });
            },
        },
        mounted() {
            this.get_ay_std_ft();
        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
     .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
    }
</style>
